"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasContainer = exports.CanvasLink = exports.maxAssetSize = exports.unitLayout = exports.CanvasContainerComponent = void 0;

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.some");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.function.name");

var _Helpers = require("../../../Helpers");

var _Constants = require("../../Constants");

var _react = _interopRequireDefault(require("react"));

var _reactSizeme = _interopRequireDefault(require("react-sizeme"));

var _reactTracking = _interopRequireDefault(require("react-tracking"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _resizer = require("../../../../Utils/resizer");

var _ExternalTrackers = require("../ExternalTrackers");

var _CanvasSlideshow = require("./CanvasSlideshow");

var _CanvasText = require("./CanvasText");

var _CanvasVideo = require("./CanvasVideo");

var _dec, _dec2, _class, _class2, _class3, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  background: black;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: -1;\n  &::before {\n    content: '';\n    background-image: url(", ");\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background-size: cover;\n    background-position: 50%;\n    z-index: 1;\n    opacity: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    max-width: 100%;\n    width: 100%;\n    height: auto;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    padding: 0;\n    width: 100%;\n    height: 400px;\n    min-height: fit-content;\n    flex-direction: column;\n    justify-content: flex-start;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 460px;\n  color: #000;\n  text-decoration: none;\n  align-items: center;\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: ", "\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    max-width: 100%;\n    height: auto;\n    max-height: initial;\n    object-fit: contain;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object['ke' + 'ys'](descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object['define' + 'Property'](target, property, desc); desc = null; } return desc; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CanvasContainerComponent = (_dec = (0, _reactTracking.default)(), _dec2 = (0, _reactTracking.default)(function (props, state, _ref) {
  var _ref2 = _slicedToArray(_ref, 1),
      e = _ref2[0];

  if (!isVideoClickArea(e)) {
    return {
      action: "Click",
      label: "Display ad clickthrough",
      entity_type: "display_ad",
      campaign_name: props.campaign.name,
      unit_layout: unitLayout(props)
    };
  }
}), _dec(_class = (_class2 = (_temp = _class3 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CanvasContainerComponent, _React$Component);

  function CanvasContainerComponent(props) {
    var _this;

    _classCallCheck(this, CanvasContainerComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CanvasContainerComponent).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "canvasVideoHandlers", void 0);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isMounted: false
    });

    _this.openLink = _this.openLink.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CanvasContainerComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    } // TODO: Ensure that full element can be clicked on video complete
    // Prevent links from blocking video playback.

  }, {
    key: "openLink",
    value: function openLink(e) {
      e.preventDefault();

      if (!isVideoClickArea(e)) {
        if (this.canvasVideoHandlers) {
          this.canvasVideoHandlers.pauseVideo();
        }

        var url = (0, _ExternalTrackers.replaceWithCacheBuster)(e.currentTarget.attributes.href.value, (0, _Constants.getCurrentUnixTimestamp)());
        window.open(url, "_blank");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          campaign = _this$props.campaign,
          disclaimer = _this$props.disclaimer,
          size = _this$props.size,
          unit = _this$props.unit;
      var assets = unit.assets,
          cover_image_url = unit.cover_image_url,
          layout = unit.layout,
          url = unit.link.url;
      var isOverlay = layout === "overlay";
      var isSlideshow = layout === "slideshow"; // Props for Link units

      var linkProps = {
        onClick: this.openLink,
        href: url,
        target: "_blank",
        containerWidth: size.width,
        layout: layout // TODO: For whatever the slideshow leads to a race condition when rendering
        // app in Force. Defer execution and everything works fine.

      };

      if (!this.state.isMounted) {
        return _react.default.createElement("div", null);
      } // Overlay


      if (isOverlay) {
        var _backgroundUrl = assets[0].url;
        return _react.default.createElement(CanvasLink, linkProps, _react.default.createElement(Background, {
          backgroundUrl: _backgroundUrl,
          hasCoverOverlay: unit.has_cover_overlay
        }), _react.default.createElement(_CanvasText.CanvasText, {
          unit: unit
        })); // Slideshow
      } else if (isSlideshow) {
        var slideshowProps = {
          unit: unit,
          campaign: campaign,
          disclaimer: disclaimer,
          containerWidth: size.width
        };
        return _react.default.createElement(_CanvasSlideshow.CanvasSlideshow, slideshowProps, _react.default.createElement(CanvasLink, linkProps, _react.default.createElement(_CanvasText.CanvasText, {
          unit: unit,
          disclaimer: disclaimer
        }))); // Video / Image
      } else {
        var _unit$assets = _slicedToArray(unit.assets, 1),
            asset = _unit$assets[0];

        var src = asset && asset.url || "";
        var isVideo = src.includes("mp4");
        return _react.default.createElement(CanvasLink, linkProps, isVideo ? _react.default.createElement(_CanvasVideo.CanvasVideo, {
          coverUrl: cover_image_url,
          src: src,
          campaign: campaign,
          onInit: function onInit(h) {
            return _this2.canvasVideoHandlers = h;
          }
        }) : src && _react.default.createElement(Image, {
          src: (0, _resizer.crop)(src, {
            width: 1200,
            height: 760,
            isDisplayAd: true
          })
        }), _react.default.createElement(StandardContainer, null, _react.default.createElement(_CanvasText.CanvasText, {
          unit: unit,
          disclaimer: disclaimer
        })));
      }
    }
  }]);

  return CanvasContainerComponent;
}(_react.default.Component), _defineProperty(_class3, "defaultProps", {
  size: {
    width: 1250
  }
}), _temp), (_applyDecoratedDescriptor(_class2.prototype, "openLink", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "openLink"), _class2.prototype)), _class2)) || _class);
exports.CanvasContainerComponent = CanvasContainerComponent;
var Div = _styledComponents.default.div;
var responsiveLink = _styledComponents.default.a;

var unitLayout = function unitLayout(props) {
  switch (props.unit.layout) {
    case "overlay":
      return "canvas_overlay";

    case "slideshow":
      return "canvas_slideshow";

    default:
      return "canvas_standard";
  }
};

exports.unitLayout = unitLayout;

var isVideoClickArea = function isVideoClickArea(e) {
  var videoClasses = ["PlayButton", "PlayButton__PlayButtonCaret", "CanvasVideo__video", "CanvasVideo__cover"];
  var isVideo = videoClasses.some(function (c) {
    return e.target.className.includes(c);
  });
  return isVideo;
};

var maxAssetSize = function maxAssetSize(containerWidth) {
  var width = containerWidth * 0.65;
  var height = width * 0.59;
  return {
    width: width,
    height: height
  };
};

exports.maxAssetSize = maxAssetSize;

var Image = _styledComponents.default.img.withConfig({
  displayName: "CanvasContainer__Image",
  componentId: "qubp26-0"
})(["display:block;width:65%;height:100%;object-fit:cover;", ";"], _Helpers.pMedia.sm(_templateObject()));

var CanvasLink = responsiveLink(_templateObject2(), function (props) {
  return props.layout === "standard" ? "space-between;" : "center;";
}, function (props) {
  return _Helpers.pMedia.lg(_templateObject3(), props.layout !== "overlay" && "max-height: " + maxAssetSize(props.containerWidth).height + "px;");
}, _Helpers.pMedia.sm(_templateObject4()));
exports.CanvasLink = CanvasLink;

var StandardContainer = _styledComponents.default.div.withConfig({
  displayName: "CanvasContainer__StandardContainer",
  componentId: "qubp26-1"
})(["max-width:calc(35% - 20px);height:100%;margin-right:auto;", ";"], _Helpers.pMedia.sm(_templateObject5()));

var Background = Div(_templateObject6(), function (props) {
  return props.backgroundUrl && props.backgroundUrl;
}, function (props) {
  return props.hasCoverOverlay ? ".7" : "1";
});
var sizeMeOptions = {
  refreshRate: _Constants.SIZE_ME_REFRESH_RATE,
  noPlaceholder: true
};
var CanvasContainer = (0, _reactSizeme.default)(sizeMeOptions)(CanvasContainerComponent);
exports.CanvasContainer = CanvasContainer;
//# sourceMappingURL=CanvasContainer.js.map